import { createApp } from 'vue'

import App from './App.vue'
import { router } from './router/router'
import { store } from './store/store.js'
import vuetify from '@/plugins/vuetify.js'

import '@/services/init.js'

createApp(App).use(store).use(router).use(vuetify).mount('#app')

window.version = VITE_APP_VERSION
